export default "__VITE_ASSET__BHZdsuO$__"